import type { DriveStep } from 'driver.js';

export const CARD_EXPENSE_TOUR_STORAGE_KEY = 'lctf:cardExpenseTour:v1';

export const CARD_EXPENSE_TOUR_SELECTORS = {
  title: '[data-tour="card-expense-title"]',
  inbox: '[data-tour="card-expense-inbox"]',
  row: '[data-tour="card-expense-row"]',
  picker: '[data-tour="card-expense-picker"]',
  help: '[data-tour="card-expense-help"]',
} as const;

export function hasSeenCardExpenseTour(): boolean {
  try {
    return localStorage.getItem(CARD_EXPENSE_TOUR_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markCardExpenseTourSeen(): void {
  try {
    localStorage.setItem(CARD_EXPENSE_TOUR_STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function buildCardExpenseTourSteps(): DriveStep[] {
  const steps: DriveStep[] = [
    {
      popover: {
        title: 'My Card Expenses',
        description:
          'When you use a company debit card, charges land here until you assign them to a project, a purchase order, company overhead, or leave them unmatched.',
      },
    },
  ];

  const optional: { selector: string; step: DriveStep }[] = [
    {
      selector: CARD_EXPENSE_TOUR_SELECTORS.inbox,
      step: {
        element: CARD_EXPENSE_TOUR_SELECTORS.inbox,
        popover: {
          title: 'Your pending inbox',
          description: 'Each row is a QuickBooks purchase on your linked card. Work newest-first — project P&L excludes these until you categorize.',
          side: 'top',
          align: 'start',
        },
      },
    },
    {
      selector: CARD_EXPENSE_TOUR_SELECTORS.picker,
      step: {
        element: CARD_EXPENSE_TOUR_SELECTORS.picker,
        popover: {
          title: 'Pick a project',
          description: 'Suggested projects and POs appear at the top. Search a PO number to map this charge — several charges can share one PO.',
          side: 'left',
          align: 'start',
        },
      },
    },
    {
      selector: CARD_EXPENSE_TOUR_SELECTORS.help,
      step: {
        element: CARD_EXPENSE_TOUR_SELECTORS.help,
        popover: {
          title: 'Daily digest',
          description: 'On weekday mornings you’ll get a bell notification when charges are waiting. Replay this tour anytime from Help.',
          side: 'bottom',
          align: 'end',
        },
      },
    },
  ];

  for (const item of optional) {
    if (document.querySelector(item.selector)) steps.push(item.step);
  }

  return steps;
}
